import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, Fragment as _Fragment, normalizeClass as _normalizeClass, isRef as _isRef, mergeProps as _mergeProps, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "d-flex flex-column align-center" }
const _hoisted_2 = {
  key: 0,
  class: "mb-1"
}
const _hoisted_3 = {
  key: 1,
  class: "mb-1"
}


export default /*@__PURE__*/_defineComponent({
  __name: 'String',
  setup(__props) {


const { control, inputModel, handleUpdate } = inject('input') as InputInjection

// Normalize max -- zero means no limit
control.value.max = control.value.max || 0
const hasMax = computed(() => control.value.max! > 0)
const counterClass = computed(() => {
  // No max, no error
  if (!hasMax.value) return ''

  // Check if max exceeded
  return inputModel.value.length > control.value.max! ? 'text-error' : ''
})

// Show append if sync, flag, or help is present
const ui = useUiStore()
const showAppend = computed(() => {
  return (ui.showSync && control.value.sync) || control.value.flag || control.value.help
})


return (_ctx: any,_cache: any) => {
  const _component_hy_inputs_sync_marker = _resolveComponent("hy-inputs-sync-marker")!
  const _component_hy_icon = _resolveComponent("hy-icon")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_hy_inputs_help_marker = _resolveComponent("hy-inputs-help-marker")!
  const _component_v_text_field = _resolveComponent("v-text-field")!

  return (_openBlock(), _createBlock(_component_v_text_field, _mergeProps({
    modelValue: _unref(inputModel),
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(inputModel) ? (inputModel).value = $event : null))
  }, _unref(control), { "onUpdate:modelValue": _unref(handleUpdate) }), _createSlots({ _: 2 }, [
    (_unref(showAppend))
      ? {
          name: "append",
          fn: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              (_ctx.$ui.showSync && _unref(control).sync)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _createVNode(_component_hy_inputs_sync_marker, {
                      sources: _unref(control).sync
                    }, null, 8, ["sources"])
                  ]))
                : (_unref(control).flag)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                      _createVNode(_component_v_tooltip, { bottom: "" }, {
                        activator: _withCtx(({ props }) => [
                          _createElementVNode("div", _normalizeProps(_guardReactiveProps(props)), [
                            _createVNode(_component_hy_icon, {
                              name: "Warning",
                              small: ""
                            })
                          ], 16)
                        ]),
                        default: _withCtx(() => [
                          _createElementVNode("span", null, _toDisplayString(_unref(control).flag), 1)
                        ]),
                        _: 1
                      })
                    ]))
                  : (_unref(control).help)
                    ? (_openBlock(), _createBlock(_component_hy_inputs_help_marker, {
                        key: 2,
                        "help-prompt": _unref(control).help
                      }, null, 8, ["help-prompt"]))
                    : _createCommentVNode("", true)
            ])
          ]),
          key: "0"
        }
      : undefined,
    (_unref(control).counter)
      ? {
          name: "counter",
          fn: _withCtx(({ counter }) => [
            _createElementVNode("span", {
              class: _normalizeClass(_unref(counterClass))
            }, [
              _createTextVNode(_toDisplayString(counter) + " ", 1),
              (_unref(hasMax))
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(" / " + _toDisplayString(_unref(control).max), 1)
                  ], 64))
                : _createCommentVNode("", true)
            ], 2)
          ]),
          key: "1"
        }
      : undefined
  ]), 1040, ["modelValue", "onUpdate:modelValue"]))
}
}

})